import React,{Component} from 'react';

import Header from './Header';
import Left from './Left';
import Body from './Body';

import Cache from './Cache';
import Config from '../config/Config';
import WidgetAjax from './../widget/WidgetAjax';

import 'rsuite/dist/styles/rsuite-default.css';

class Frame extends Component 
{
    constructor(props)
    {
        super(props);

        this.state = {
            basePath: Config.getBasePath(),
            titleNodes:[
                // {name:"SCRM", title:"首页", path:"/home" },
                // {name:"system", title:"系统管理", path:"/home/system" }
            ],

            leftNode : [
                // {name:"home", title:"首页", path:"/home/homePage", properties:{icon:"home"} },
                // {name:"intelligentExpandCustomer",title:"智能拓客", properties:{icon:"intelligent"},
                //     subcomponents:[
                //         {name:"BusinessChance",title:"商机发现",path:"/home/businessChance", properties:{icon:"businessChance"} },
                //         {name:"enterpriseMonitoring",title:"重点企业",path:"/home/enterpriseMonitoring", properties:{icon:"enterpriseMonitoring"} },
                //     ]
                // },
                // {name:"enterpriseSearch",title:"企业搜索",path:"/home/enterpriseSearch", properties:{icon:"enterpriseSearch"} },
                // {name:"vertical",title:"垂直搜索",path:"/home/vertical", properties:{icon:"enterpriseSearch"} },
                // {name:"searchTag",title:"高级搜索",path:"/home/searchTag", properties:{icon:"searchTag"} }
                // {name:"CRM",title:"CRM",path:"/home/CRM", properties:{icon:"CRM"} }
            ],
            privileges : [
                // {name:"SCRM", title:"首页", path:"/home"},
                // {name:"home", title:"首页", path:"/home/homePage", properties:{icon:"home"} },
                // {name:"BusinessChance",title:"商机发现",path:"/home/businessChance", properties:{icon:"businessChance"} },
                // {name:"enterpriseMonitoring",title:"重点企业",path:"/home/enterpriseMonitoring", properties:{icon:"enterpriseMonitoring"} },
                // {name:"searchTag",title:"高级搜索",path:"/home/searchTag", properties:{icon:"searchTag"} },
                // {name:"vertical",title:"垂直搜索",path:"/home/vertical", properties:{icon:"enterpriseSearch"} },
                // {name:"entityDetail",title:"企业详情",path:"/home/entityDetail", properties:{icon:"entityDetail"} },
                // {name:"enterpriseSearch",title:"企业搜索",path:"/home/enterpriseSearch", properties:{icon:"enterpriseSearch"} },
                
                // {name:"system", title:"系统管理", path:"/home/system" },
                // {name:"user",title:"用户管理",path:"/home/user", properties:{icon:"user"} },
                // {name:"userCreate",title:"创建用户",path:"/home/userCreate"},
                // {name:"group",title:" 角色管理",path:"/home/group", properties:{icon:"group"} },
                // {name:"department",title:"部门管理",path:"/home/department", properties:{icon:"department"} },
                // {name:"departmentPrivilege",title:"部门权限",path:"/home/departmentPrivilege" }, 
                // {name:"UserLog",title:"日志管理",path:"/home/userLog", properties:{icon:"userLog"} },
                // {name:"Component",title:"组件管理" , path:"/home/component"},
                // {name:"Uims",title:"接口管理" , path:"/home/Uims"},
                // {name:"CRM",title:"CRM",path:"/home/CRM", properties:{icon:"CRM"} },
                // {name:"departmentuser",title:"部门用户", type:"POPUP", path:"/home/departmentuser"},
                // {name:"groupPrivilege",title:"角色权限", type:"POPUP", path:"/home/groupPrivilege"},
                // {name:"groupUser",title:"角色用户", type:"POPUP", path:"/home/groupUser"},
            ],
            leftNodes:{
                // SCRM:[
                //     {name:"home", title:"首页", path:"/home/homePage", properties:{icon:"home"} },
                //     {name:"intelligentExpandCustomer",title:"智能拓客", properties:{icon:"intelligent"},
                //         subcomponents:[
                //             {name:"BusinessChance",title:"商机发现",path:"/home/businessChance", properties:{icon:"businessChance"} },
                //             {name:"enterpriseMonitoring",title:"重点企业",path:"/home/enterpriseMonitoring", properties:{icon:"enterpriseMonitoring"} },
                //         ]
                //     },
                //     {name:"enterpriseSearch",title:"企业搜索",path:"/home/enterpriseSearch", properties:{icon:"enterpriseSearch"} },  
                //     {name:"vertical",title:"垂直搜索",path:"/home/vertical", properties:{icon:"enterpriseSearch"} },
                //     {name:"searchTag",title:"高级搜索",path:"/home/searchTag", properties:{icon:"searchTag"} },
                //     {name:"association",title:"获客工具", properties:{icon:"intelligent"}, 
                //         subcomponents:[
                //             {name:"MultipointAssociation",title:"多点关联",path:"/home/multipointassociation"},
                //             {name:"SinglePointAssociation",title:"单点关联",path:"/home/singlepointassociation"},
                //     ]},
                // ],
                // system:[
                //     {name:"user",title:"用户管理",path:"/home/user", properties:{icon:"user"},
                //         subcomponents:[
                //             {name:"userCreate",title:"用户创建", type:"POPUP", path:"/home/userCreate"},
                //         ]    
                //     },
                //     {name:"group",title:" 角色管理",path:"/home/group", properties:{icon:"group"},
                //         subcomponents:[
                //             {name:"groupPrivilege",title:"角色权限", type:"POPUP", path:"/home/groupPrivilege"},
                //             {name:"groupUser",title:"角色用户", type:"POPUP", path:"/home/groupUser"},
                //         ]     
                //     },
                //     {name:"department",title:"部门管理",path:"/home/department", properties:{icon:"department"},
                //         subcomponents:[
                //             {name:"departmentPrivilege",title:"部门权限", type:"POPUP", path:"/home/departmentPrivilege"},
                //             {name:"departmentuser",title:"部门用户", type:"POPUP", path:"/home/departmentuser"},
                //         ]     
                //     },
                //     {name:"UserLog",title:"日志管理",path:"/home/userLog", properties:{icon:"userLog"} },
                //     {name:"Management",title:"菜单管理", properties:{icon:"department"}, 
                //         subcomponents:[
                //             {name:"Component",title:"组件管理" , path:"/home/component"},
                //             {name:"Uims",title:"接口管理" , path:"/home/Uims"},
                //     ]},
                // ]
              
            },
            nodes : undefined,
            systemTitle : "银行对公营销获客系统",
            titleActiveKey : "",
            leftActiveKey : undefined
		};

        this.leftOnSelect = this.leftOnSelect.bind(this);
        this.headerOnSelect = this.headerOnSelect.bind(this);
        this.freshPage = this.freshPage.bind(this);
        this.redrict = this.redrict.bind(this);

        this.findNode = this.findNode.bind(this);
        this.loadUserPage= this.loadUserPage.bind(this);
        this.onLoadUserPage= this.onLoadUserPage.bind(this);
        this.buildNodes = this.buildNodes.bind(this);
        this.history = this.history.bind(this);

        this.myRef = this;
    }

    componentDidMount()
    {
        this.loadUserPage()
    }

    loadUserPage()
    {
        let { basePath } = this.state;

        WidgetAjax.ajax({ url: basePath + "/component", callback: this.onLoadUserPage});
    }

    onLoadUserPage(result)
    {
        if( result.status===0 )
        {
            if( result.result!==undefined && result.result.frame!==undefined )
            {
                this.state["nodes"] = result.result.frame;
            }
            
            if( result.result!==undefined && result.result.privileges!==undefined )
            {
                this.state["privileges"] = result.result.privileges;
            }

            this.buildNodes( this.state.nodes );
        }
        else if( result.status===10 )
        {
            Cache.logout(this.props);
        }
    }

    /**
     * 创建菜单节点
     * @param {*} nodes 
     * @returns 
     */
    buildNodes( nodes )
    {
        let titleNodes = [], leftNodes = {}, titleActiveKey, leftNode = [];

        if( nodes!==undefined && nodes.length>0 )
        {
            for( let i=0; i<nodes.length; i++ )
            {
                if( nodes[i].type==="PAGE" || nodes[i].type==="LINK" || nodes[i].type===undefined )
                {
                    titleNodes.push(nodes[i]);

                    if( leftNodes[nodes[i].name] ===undefined )
                    {
                        leftNodes[nodes[i].name] = [];
                    }
                    
                    if( nodes[i].subcomponents!==undefined )
                    {
                        leftNodes[nodes[i].name].push( ...nodes[i].subcomponents );
                    }

                    if( i===0 )
                    {
                        titleActiveKey = nodes[i].name;
                    }
                }
            }
        }

        if( leftNodes[titleActiveKey]!==undefined )
        {
            leftNode.push( ...leftNodes[titleActiveKey] );
        }
        
        this.setState({titleNodes:titleNodes, leftNodes:leftNodes, titleActiveKey:titleActiveKey, leftNode:leftNode});
    }

    /**
     * 头部菜单选择后回调函数
     * @param {*} key 
     */
    headerOnSelect(key) 
    {
        let { titleNodes } = this.state;

        let leftNode = this.state.leftNodes[key];

        this.setState({leftNode, titleActiveKey: key});

        for(let item of titleNodes )
        {
            if( item.name===key )
            {
                let state = {
                    node : item,
                    item : item,
                    children:leftNode
                };

                this.redrict(item.path, state, false);
            }
        }
    }

    leftOnSelect( key )
    {
        this.setState({leftActiveKey: key});
    }

    freshPage()
    {
        window.location.reload() ;
    }

    redrict( path, state, isFresh)
    {
        this.props.children.props.history.push({pathname:path, state:state});
        
        if( isFresh!==undefined && isFresh!==false )
        {
            this.freshPage();
        }
       
    }

    findNode( nodeProps )
    {
        const { titleNodes, leftNodes, privileges } = this.state;

        let { titleActiveKey, leftActiveKey } = this.state;

        let path = "", node, item;
       
        if( nodeProps!==undefined && nodeProps.match!==undefined )
        {
            path = nodeProps.match.path;
        }

        if( nodeProps!==undefined && nodeProps.location!==undefined && nodeProps.location.state!==undefined )
        {
            item = nodeProps.location.state.node;
        }

        if( path!==undefined && path!==null && path!=="" )
        {
            node = this.findNodeByNodes(privileges, path, item, true);

            if( node!==undefined && node!==null )
            {
                let frameNode = this.findNodeByNodes(titleNodes, path, node, false);

                if( frameNode!==undefined && frameNode!==null )
                {
                    let leftNode = leftNodes[frameNode.name];

                    return {node:frameNode, leftNode:leftNode, titleActiveKey: frameNode.name }
                }
                
                for( let key in leftNodes )
                {
                    frameNode = this.findNodeByNodes(leftNodes[key], path, node, true);

                    if( frameNode!==undefined && frameNode!==null )
                    {
                        titleActiveKey = key;
                        break;
                    }
                }

                if( frameNode!==undefined && frameNode!==null )
                {
                    let leftNode = leftNodes[titleActiveKey];

                    this.state["leftNode"] = leftNode;
                    this.state["titleActiveKey"] = titleActiveKey;
                    this.state["leftActiveKey"] = frameNode.name;

                    //return {node:frameNode, leftNode:leftNode, titleActiveKey: titleActiveKey, }
                }
                else
                {
                    //this.state["leftNode"] = undefined;
                    this.state["titleActiveKey"] = undefined;
                    this.state["leftActiveKey"] = node.name;
                    //return {node:node, leftNode:undefined, titleActiveKey: undefined }
                }
            }
        }
        
    }

    /**
     * 通过path查找节点
     * @param {*} nodes 
     * @param {*} path 
     * @param {*} item 当前节点 
     * @param {*} isRecurse 是否需要递归查找
     * @returns 
     */
    findNodeByNodes(nodes, path, item, isRecurse)
    {
        let node = null;

        if( nodes!==undefined && nodes.length>0 )
        {
            for(let i=0; i<nodes.length; i++)
            {
                if( item!==undefined && item!==null && item!=="" )
                {
                    if( nodes[i].name!==undefined && item!==undefined && item!==null && nodes[i].name===item.name )
                    {
                        node = nodes[i];
                    }
                    else if( nodes[i].subcomponents!==undefined && isRecurse===true )
                    {
                        node = this.findNodeByNodes(nodes[i].subcomponents, path, item, true);
                    }
                }
                else
                {
                    if( nodes[i].path!==undefined && (nodes[i].path===path || ( "/" + nodes[i].path )===path || ( "/" + nodes[i].path + "/" )===path ||  ( nodes[i].path + "/" )===path) )
                    {
                        node = nodes[i];
                    }
                    else if( nodes[i].subcomponents!==undefined && isRecurse===true )
                    {
                        node = this.findNodeByNodes(nodes[i].subcomponents, path, item, true);
                    }
                }

                if( node!==null )
                {
                    break;
                }
            }

            return node;
        }
    }

    history(type){
        this.props.history.push(type)
    }

    render() 
	{    
        const { titleNodes, systemTitle, privileges} = this.state;

        this.findNode(this.props.children.props);

        let { leftNode, titleActiveKey, disposalData, leftActiveKey} = this.state;
 
        if( privileges===undefined || privileges.length===0 )
        {
            return <div></div>
        }

        const { model } = this.props;

        if( model==="home" )
        {
            let state = {children:leftNode};

            if( this.props.children.props.location!==undefined && this.props.children.props.location.state!==undefined)
            {
                state = {...this.props.children.props.location.state, ...state};
            }
        
            this.props.children.props.history.push({pathname:this.props.children.props.match.path, state:state});
        }

        const childrenBody = React.Children.map(this.props.children, child =>
            React.cloneElement(child, { reload: this.reload })
        );

        switch( model )
        {
            case "page":
            {
                return (
                    <div className="frame-page">
                        <Body>{this.props.children}</Body>
                    </div> 
                );
            }
            case "table":
            {
                return (
                    <div className="frame-table">
                        <Header headerOnSelect={this.headerOnSelect} titleNode={titleNodes} systemTitle={systemTitle} activeKey={titleActiveKey} 
                             freshPage={this.freshPage} redrict={this.redrict}/>
                        <Body>{this.props.children}</Body>
                    </div> 
                );
            }
            case "home" :
            {
                return (
                    <div className="frame-page">
                        <Body>{this.props.children}</Body>
                    </div> 
                );
            }
            default :
            {
                return (
                    <div className="frame">
                        <Header headerOnSelect={this.headerOnSelect} titleNode={titleNodes} history={this.history} systemTitle={systemTitle} activeKey={titleActiveKey}  
                            freshPage={this.freshPage} redrict={this.redrict}/>
                        <Left leftNode={leftNode} disposalData={disposalData} leftActiveKey={leftActiveKey} redrict={this.redrict} leftOnSelect={this.leftOnSelect}/>
                        {/* <Body>{this.props.children}</Body> */}
                        <Body>{childrenBody}</Body>
                    </div> 
                );
            }
        }
    }
} 

export default Frame